export default {
    terminal: {
        TERMINAL_ADDED: 'Terminal uspešno dodat',
        TERMINAL_EDITED: 'Terminal uspešno izmenjen',
    },
    company: {
        COMPANY_ADDED: 'Kompanija uspešno dodata',
        COMPANY_EDITED: 'Kompanija uspešno izmenjena',
    },
    place: {
        PLACE_ADDED: 'Lokal uspešno dodat',
        PLACE_EDITED: 'Lokal uspešno izmenjen',
    },
    product: {
        PRODUCT_ADDED: 'Proizvod uspešno dodat',
        PRODUCT_EDITED: 'Proizvod uspešno izmenjen',
    },
    nestedProduct: {
        NESTED_PRODUCT_ADDED: 'Prilog uspešno dodat',
        NESTED_PRODUCT_EDITED: 'Prilog uspešno izmenjen',
    },
    website: {
        WEBSITE_ADDED: 'Sajt uspešno dodat',
        WEBSITE_EDITED: 'Sajt uspešno izmenjen',
    },
    company_owner: {
        COMPANY_OWNER_ADDED: 'Vlasnik kompanije uspešno dodat',
        COMPANY_OWNER_EDITED: 'Vlasnik kompanije uspešno izmenjen',
    },
    order: {
        ORDER_EDITED: 'Porudžbina uspešno izmenjena',
    },
    productCategory: {
        PRODUCT_CATEGORY_ADDED: 'Kategorija proizvoda uspešno dodata',
        PRODUCT_CATEGORY_EDITED: 'Kategorija proizvoda uspešno izmenjena',
    },
    nestedProductCategory: {
        NESTED_PRODUCT_CATEGORY_ADDED: 'Kategorija priloga/dodatka uspešno dodata',
        NESTED_PRODUCT_CATEGORY_EDITED: 'Kategorija priloga/dodatka uspešno izmenjena',
    },
    promotion: {
        PROMOTION_ADDED: 'Promocija uspešno dodata',
        PROMOTION_EDITED: 'Promocija uspešno izmenjena',
    },
};
